import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

class AdminMenu extends Component {
  render() {
    const { email, authentication, org } = this.props;

    const org_id =
      org.current_org_id === null
        ? authentication.user.org_id
        : org.current_org_id;


    const filtered_list = org?.list?.filter(org => org.org_id === org_id);
    const matching_org = filtered_list?.[0];
    const allow_doc_types = matching_org?.allow_doc_types;
    const allow_model_management = matching_org?.allow_model_management;
    const is_tagtech_admin = authentication?.user?.org_id === 1 && authentication?.user?.roles?.find(permitted => "ADMIN" === permitted.toUpperCase());

    return (
      <>


        <li className="admin-menu">
          <a className="loginlink">
            admin&nbsp;&nbsp;<span className="arrow-down"></span>
          </a>

          <div className="admin-content">

            <Link to="/orgs" action="logs">
              orgs
            </Link>
            <Link to="/users" action="logs">
              users
            </Link>

            {
              allow_doc_types && (
                <>
                  <Link to={"/org/" + org_id + "/doctypes"} action="logs">
                    doc types
                  </Link>
                </>

              )
            }
            {
              (allow_model_management || is_tagtech_admin) && (
                <>
                  <Link to={"/org/" + org_id + "/pagetypes"}>
                    page types
                  </Link>
                </>
              )

            }



            {authentication.user.org_id === 1 && (

              <>

                <hr></hr>
                <Link to={"/org/" + org_id + "/ingestion"} action="ingestion">
                  ingestion
                </Link>
                <Link to={"/org/" + org_id + "/reports/airtable"}>
                  ops
                </Link>
              </>
            )}
          </div>
        </li>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { authentication, org } = state;
  return {
    authentication,
    org,
  };
}

const connectedAdminMenu = connect(mapStateToProps)(AdminMenu);
export { connectedAdminMenu as AdminMenu };
